import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { UserAvatar, Text, Space } from '@redlink/components/atoms';

export const PreviewUserProfileInfo = memo(
  ({
    style,
    imageUrl,
    title,
    subtitle,
    emailAddress,
    cellPhone,
    isCompact = false,
  }) => {
    const { styles } = useStyle();
    return (
      <View style={[styles.container, style]}>
        <UserAvatar source={{ uri: imageUrl }} />
        <Space size={8} />
        <Text style={styles.titleText}>{title}</Text>
        <View
          style={[
            isCompact
              ? styles.extraDataContainerCompact
              : styles.extraDataContainer,
          ]}
        >
          <Text style={styles.subTitleText}>{subtitle}</Text>
          <Space size={15} />
          <Text en style={styles.secondarySubTitleText}>
            {emailAddress}
          </Text>
          <Space size={8} />
          <Text style={styles.secondarySubTitleText}>{cellPhone}</Text>
        </View>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    alignItems: 'center',
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: 16,
    color: colors.coverText,
    lineHeight: 32,
  },
  subTitleText: {
    fontSize: 14,
    color: colors.coverText,
    textAlign: 'center',
    marginHorizontal: 45,
    opacity: 0.7,
  },
  secondarySubTitleText: {
    fontSize: 14,
    color: colors.coverText,
    textAlign: 'center',
    marginHorizontal: 45,
  },
  extraDataContainer: {
    alignItems: 'center',
  },
  extraDataContainerCompact: {
    marginTop: 10,
    alignItems: 'center',
  },
}));
